import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	isRequest: ForNodeType<boolean>;
	onSetIsRequest: (value: boolean) => void;
};

export const QuestionDayTripPlanIsRequest = ({ onSetIsRequest, isRequest }: Props) => {
	const label = "リクエスト予約";
	const guide =
		"ホテルポリシーでリクエスト予約を設定していない場合でもチェックを入れたプランはリクエスト予約のみを受け付けることができます。<br /><br />※ゲストよりリクエストが送られた時点で一時的に在庫を確保いたします。<br />※<strong>宿泊日当日までに施設よりゲストへの連絡がない場合は予約が成立したことになります。</strong>予約がキャンセルされずゲストが来訪してしまう可能性がありますのでご注意ください。<b>事前決済のみ</b>での販売になります。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={label}
			guide={guide}
			isEdited={isRequest.isEdited}
			hasError={Boolean(isRequest.error)}
			inputChildren={
				<CheckboxField
					value={isRequest.value}
					label={"このプランで予約した場合リクエスト予約のみを受け付ける"}
					handleChange={onSetIsRequest}
					errorMessage={isRequest.error}
				/>
			}
		/>
	);
};

QuestionDayTripPlanIsRequest.displayName = "QuestionDayTripPlanIsRequest";
